import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 xl:p-8" };
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3" };
const _hoisted_3 = { class: "text-2xl font-semibold text-eblack-900" };
const _hoisted_4 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_5 = ["disabled"];
const _hoisted_6 = {
    key: 0,
    class: "rounded-lg border border-dashed border-ewhite-300 bg-white p-8 text-center text-sm text-eblack-500"
};
const _hoisted_7 = {
    key: 1,
    class: "flex flex-wrap items-center justify-between gap-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
    "data-test": "tenant-billing-error"
};
const _hoisted_8 = {
    key: 2,
    class: "rounded-lg border border-ewhite-200 bg-white p-8 text-center text-sm text-eblack-500"
};
const _hoisted_9 = { class: "grid gap-3 md:grid-cols-3" };
const _hoisted_10 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_11 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_12 = { class: "mt-2 text-lg font-semibold text-eblack-900" };
const _hoisted_13 = { class: "mt-2 text-xs text-eblack-500" };
const _hoisted_14 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_15 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_16 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_17 = { class: "mt-1 text-xs text-eblack-500" };
const _hoisted_18 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_19 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_20 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_21 = { class: "mt-1 text-xs text-eblack-500" };
const _hoisted_22 = { class: "grid gap-5 xl:grid-cols-[minmax(0,1fr)_360px]" };
const _hoisted_23 = { class: "rounded-lg border border-ewhite-200 bg-white xl:col-start-1" };
const _hoisted_24 = { class: "border-b border-ewhite-100 p-4" };
const _hoisted_25 = { class: "font-semibold text-eblack-900" };
const _hoisted_26 = { class: "grid gap-0 divide-y divide-ewhite-100 text-sm" };
const _hoisted_27 = { class: "grid gap-1 px-4 py-3 sm:grid-cols-[220px_1fr]" };
const _hoisted_28 = { class: "text-eblack-500" };
const _hoisted_29 = { class: "font-medium text-eblack-900" };
const _hoisted_30 = { class: "grid gap-1 px-4 py-3 sm:grid-cols-[220px_1fr]" };
const _hoisted_31 = { class: "text-eblack-500" };
const _hoisted_32 = { class: "font-medium text-eblack-900" };
const _hoisted_33 = { class: "grid gap-1 px-4 py-3 sm:grid-cols-[220px_1fr]" };
const _hoisted_34 = { class: "text-eblack-500" };
const _hoisted_35 = { class: "font-medium text-eblack-900" };
const _hoisted_36 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_37 = { class: "border-b border-ewhite-100 p-4" };
const _hoisted_38 = { class: "font-semibold text-eblack-900" };
const _hoisted_39 = { class: "grid gap-4 p-4" };
const _hoisted_40 = { value: "" };
const _hoisted_41 = ["value"];
const _hoisted_42 = ["placeholder"];
const _hoisted_43 = {
    key: 0,
    class: "text-xs text-eblack-500"
};
const _hoisted_44 = {
    key: 1,
    class: "text-xs text-red-700",
    "data-test": "tenant-proof-error"
};
const _hoisted_45 = ["placeholder"];
const _hoisted_46 = ["placeholder"];
const _hoisted_47 = ["disabled"];
const _hoisted_48 = {
    key: 1,
    class: "text-sm text-eblack-500"
};
const _hoisted_49 = { class: "flex flex-wrap items-start justify-between gap-2" };
const _hoisted_50 = { class: "font-semibold text-eblack-900" };
const _hoisted_51 = { class: "text-eblack-500" };
const _hoisted_52 = ["href"];
const _hoisted_53 = {
    key: 0,
    class: "mt-2 text-xs text-eblack-500"
};
const _hoisted_54 = { key: 0 };
const _hoisted_55 = { class: "grid gap-5 xl:col-start-2 xl:row-start-1" };
const _hoisted_56 = {
    key: 0,
    class: "rounded-lg border border-eorange-200 bg-white p-4",
    "data-test": "tenant-provider-setup-card"
};
const _hoisted_57 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_58 = { class: "mt-3 text-sm text-eblack-600" };
const _hoisted_59 = ["disabled"];
const _hoisted_60 = {
    key: 0,
    class: "mt-3 text-sm text-egreen-700",
    "data-test": "tenant-provider-setup-success"
};
const _hoisted_61 = {
    key: 1,
    class: "mt-3 text-sm text-red-700",
    "data-test": "tenant-provider-setup-error"
};
const _hoisted_62 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_63 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_64 = { class: "mt-3 text-sm text-eblack-600" };
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { IconRefresh } from "@tabler/icons-vue";
import { useAuthStore } from "@/domains/auth";
import { useBillingStore, useBillingFormatting } from "@/domains/billing";
import { createAndUploadFile } from "@/services/upload-service";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubscriptionIndex',
    setup(__props) {
        const store = useBillingStore();
        const authStore = useAuthStore();
        const { t, locale } = useI18n();
        const { money, dateLabel, statusLabel, modeLabel, actionLabel, actionDescription, invoiceLabel, priceSourceLabel, statusClass, actionClass, } = useBillingFormatting();
        const summary = computed(() => store.tenantSummary);
        const setupState = ref("idle");
        const setupError = ref(null);
        const proofFile = ref(null);
        const proofFileInput = ref(null);
        const proofError = ref(null);
        const proofUploading = ref(false);
        const proofForm = reactive({
            invoice_id: "",
            evidence_url: "",
            reference: "",
            note: "",
        });
        const providerSetupPending = computed(() => summary.value?.payment_method?.setup_required === true ||
            summary.value?.provider?.subscription.setup_status ===
                "requires_payment_method" ||
            summary.value?.provider?.account.setup_status === "requires_payment_method");
        const openInvoices = computed(() => store.tenantInvoices.filter((invoice) => invoice.status === "open"));
        const canSubmitProof = computed(() => Boolean(proofForm.invoice_id && (proofForm.evidence_url || proofFile.value)));
        const proofFileName = computed(() => proofFile.value?.name ?? "");
        onMounted(() => {
            loadSummary();
        });
        watch(() => authStore.currentOrgId, () => loadSummary());
        async function loadSummary() {
            if (!authStore.currentOrgId)
                return;
            await Promise.all([
                store.fetchTenantSummary(authStore.currentOrgId),
                store.fetchTenantInvoices(authStore.currentOrgId),
            ]);
            if (!proofForm.invoice_id && openInvoices.value[0]) {
                proofForm.invoice_id = openInvoices.value[0].id;
            }
        }
        async function submitProof() {
            if (!authStore.currentOrgId || !canSubmitProof.value)
                return;
            proofError.value = null;
            const payload = {};
            if (proofFile.value) {
                proofUploading.value = true;
                try {
                    const result = await createAndUploadFile(proofFile.value, {
                        folder: "pdfs",
                        metadata: {
                            purpose: "manual_invoice_proof",
                            invoice_id: proofForm.invoice_id,
                        },
                    });
                    payload.evidence_storage_id = result.storageId;
                }
                catch (error) {
                    proofError.value =
                        error instanceof Error ? error.message : "Could not upload proof";
                    return;
                }
                finally {
                    proofUploading.value = false;
                }
            }
            else {
                payload.evidence_url = proofForm.evidence_url;
            }
            if (proofForm.reference)
                payload.reference = proofForm.reference;
            if (proofForm.note)
                payload.note = proofForm.note;
            await store.submitManualInvoiceProof(authStore.currentOrgId, proofForm.invoice_id, payload);
            proofForm.evidence_url = "";
            proofForm.reference = "";
            proofForm.note = "";
            proofFile.value = null;
            if (proofFileInput.value)
                proofFileInput.value.value = "";
        }
        function selectProofFile(event) {
            const input = event.target;
            const file = input.files?.[0] ?? null;
            proofError.value = null;
            if (!file) {
                proofFile.value = null;
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                proofError.value = t("settings.billing.errors.proof_file_too_large");
                proofFile.value = null;
                input.value = "";
                return;
            }
            if (file.type !== "application/pdf" && !file.type.startsWith("image/")) {
                proofError.value = t("settings.billing.errors.proof_file_type");
                proofFile.value = null;
                input.value = "";
                return;
            }
            proofFile.value = file;
        }
        async function startProviderSetup() {
            if (!authStore.currentOrgId)
                return;
            setupState.value = "loading";
            setupError.value = null;
            try {
                const intent = await store.createProviderSetupIntent(authStore.currentOrgId, {
                    locale: locale.value,
                });
                await loadOnvoSdk();
                const onvo = window.Onvo ?? window.onvo;
                if (!onvo?.pay) {
                    throw new Error(t("settings.billing.provider.sdk_unavailable"));
                }
                await onvo.pay({
                    publicKey: intent.publishable_key,
                    customerId: intent.customer_id,
                    subscriptionId: intent.subscription_id,
                    paymentType: intent.payment_type,
                    locale: intent.locale,
                });
                setupState.value = "success";
                await loadSummary();
            }
            catch (error) {
                setupState.value = "error";
                setupError.value =
                    error instanceof Error
                        ? error.message
                        : t("settings.billing.provider.setup_error");
            }
        }
        async function loadOnvoSdk() {
            const existing = document.querySelector('script[data-onvo-sdk="true"]');
            if (existing)
                return;
            await new Promise((resolve, reject) => {
                const script = document.createElement("script");
                script.src = "https://sdk.onvopay.com/sdk.js";
                script.async = true;
                script.dataset.onvoSdk = "true";
                script.onload = () => resolve();
                script.onerror = () => reject(new Error(t("settings.billing.provider.sdk_load_failed")));
                document.head.appendChild(script);
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(t)("settings.billing.tenant.title")), 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("settings.billing.tenant.description")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex h-9 items-center gap-2 rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                        disabled: _unref(store).isLoading || !_unref(authStore).currentOrgId,
                        "data-test": "tenant-billing-refresh",
                        onClick: loadSummary
                    }, [
                        _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.refresh")), 1)
                    ], 8, _hoisted_5)
                ]),
                (!_unref(authStore).currentOrgId)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_6, _toDisplayString(_unref(t)("settings.billing.tenant.select_org")), 1))
                    : (_unref(store).error)
                        ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(_unref(store).error), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "rounded-md border border-red-200 px-2.5 py-1 font-medium hover:bg-red-100",
                                onClick: loadSummary
                            }, _toDisplayString(_unref(t)("settings.billing.actions.retry")), 1)
                        ]))
                        : (_unref(store).isLoading && !summary.value)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_8, _toDisplayString(_unref(t)("settings.billing.loading")), 1))
                            : (summary.value)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                    _createElementVNode("section", _hoisted_9, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("p", _hoisted_11, _toDisplayString(_unref(t)("settings.billing.cards.plan")), 1),
                                            _createElementVNode("p", _hoisted_12, _toDisplayString(summary.value.subscription.plan_name || _unref(t)("settings.billing.none")), 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["mt-2 inline-flex rounded-full px-2 py-0.5 text-xs font-semibold", _unref(statusClass)(summary.value.subscription.status)])
                                            }, _toDisplayString(_unref(statusLabel)(summary.value.subscription.status)), 3),
                                            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(modeLabel)(summary.value.subscription.billing_mode)), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("settings.billing.cards.seats")), 1),
                                            _createElementVNode("p", _hoisted_16, _toDisplayString(summary.value.seats.billable_seats), 1),
                                            _createElementVNode("p", _hoisted_17, _toDisplayString(_unref(t)("settings.billing.tenant.active_seats", {
                                                count: summary.value.seats.active_seats,
                                            })), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_18, [
                                            _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)("settings.billing.cards.expected")), 1),
                                            _createElementVNode("p", _hoisted_20, _toDisplayString(_unref(money)(summary.value.amounts.expected_monthly_charge_minor, summary.value.amounts.currency)), 1),
                                            _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("settings.billing.cards.open_balance")) + ": " + _toDisplayString(_unref(money)(summary.value.amounts.open_invoice_amount_minor, summary.value.amounts.currency)), 1)
                                        ])
                                    ]),
                                    _createElementVNode("section", _hoisted_22, [
                                        _createElementVNode("div", _hoisted_23, [
                                            _createElementVNode("div", _hoisted_24, [
                                                _createElementVNode("h2", _hoisted_25, _toDisplayString(_unref(t)("settings.billing.tenant.details_title")), 1)
                                            ]),
                                            _createElementVNode("dl", _hoisted_26, [
                                                _createElementVNode("div", _hoisted_27, [
                                                    _createElementVNode("dt", _hoisted_28, _toDisplayString(_unref(t)("settings.billing.fields.next_charge")), 1),
                                                    _createElementVNode("dd", _hoisted_29, _toDisplayString(_unref(dateLabel)(summary.value.lifecycle.next_charge_at)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_30, [
                                                    _createElementVNode("dt", _hoisted_31, _toDisplayString(_unref(t)("settings.billing.fields.plan_price")), 1),
                                                    _createElementVNode("dd", _hoisted_32, [
                                                        _createTextVNode(_toDisplayString(_unref(money)(summary.value.seats.seat_unit_amount_minor, summary.value.amounts.currency)) + " ", 1),
                                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-eblack-400" }, "·", -1)),
                                                        _createTextVNode(" " + _toDisplayString(_unref(priceSourceLabel)(summary.value.amounts.price_source)), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_33, [
                                                    _createElementVNode("dt", _hoisted_34, _toDisplayString(_unref(t)("settings.billing.fields.latest_invoice")), 1),
                                                    _createElementVNode("dd", _hoisted_35, _toDisplayString(summary.value.invoice.status
                                                        ? _unref(invoiceLabel)(summary.value.invoice.status)
                                                        : _unref(t)("settings.billing.none")), 1)
                                                ])
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_36, [
                                            _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("h2", _hoisted_38, _toDisplayString(_unref(t)("settings.billing.detail.invoice_history")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_39, [
                                                (openInvoices.value.length > 0)
                                                    ? (_openBlock(), _createElementBlock("form", {
                                                        key: 0,
                                                        class: "grid gap-3 rounded-lg bg-ewhite-50 p-3",
                                                        "data-test": "tenant-proof-form",
                                                        onSubmit: _withModifiers(submitProof, ["prevent"])
                                                    }, [
                                                        _withDirectives(_createElementVNode("select", {
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((proofForm.invoice_id) = $event)),
                                                            class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                                        }, [
                                                            _createElementVNode("option", _hoisted_40, _toDisplayString(_unref(t)("settings.billing.fields.latest_invoice")), 1),
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openInvoices.value, (invoice) => {
                                                                return (_openBlock(), _createElementBlock("option", {
                                                                    key: invoice.id,
                                                                    value: invoice.id
                                                                }, " #" + _toDisplayString(invoice.id) + " · " + _toDisplayString(_unref(money)(invoice.total_minor, invoice.currency)), 9, _hoisted_41));
                                                            }), 128))
                                                        ], 512), [
                                                            [_vModelSelect, proofForm.invoice_id]
                                                        ]),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((proofForm.evidence_url) = $event)),
                                                            type: "url",
                                                            class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                            "data-test": "tenant-proof-url",
                                                            placeholder: _unref(t)('settings.billing.fields.proof_url')
                                                        }, null, 8, _hoisted_42), [
                                                            [
                                                                _vModelText,
                                                                proofForm.evidence_url,
                                                                void 0,
                                                                { trim: true }
                                                            ]
                                                        ]),
                                                        _createElementVNode("input", {
                                                            ref_key: "proofFileInput",
                                                            ref: proofFileInput,
                                                            type: "file",
                                                            accept: "application/pdf,image/*",
                                                            class: "rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                                            "data-test": "tenant-proof-file",
                                                            onChange: selectProofFile
                                                        }, null, 544),
                                                        (proofFileName.value)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(proofFileName.value), 1))
                                                            : _createCommentVNode("", true),
                                                        (proofError.value)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(proofError.value), 1))
                                                            : _createCommentVNode("", true),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((proofForm.reference) = $event)),
                                                            class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                            placeholder: _unref(t)('settings.billing.fields.payment_reference')
                                                        }, null, 8, _hoisted_45), [
                                                            [
                                                                _vModelText,
                                                                proofForm.reference,
                                                                void 0,
                                                                { trim: true }
                                                            ]
                                                        ]),
                                                        _withDirectives(_createElementVNode("textarea", {
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((proofForm.note) = $event)),
                                                            class: "min-h-16 rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                                            placeholder: _unref(t)('settings.billing.fields.note')
                                                        }, null, 8, _hoisted_46), [
                                                            [
                                                                _vModelText,
                                                                proofForm.note,
                                                                void 0,
                                                                { trim: true }
                                                            ]
                                                        ]),
                                                        _createElementVNode("button", {
                                                            type: "submit",
                                                            class: "h-9 rounded-lg bg-eblack-900 px-3 text-sm font-semibold text-white hover:bg-eblack-800 disabled:opacity-60",
                                                            disabled: _unref(store).isSaving || proofUploading.value || !canSubmitProof.value,
                                                            "data-test": "tenant-submit-proof"
                                                        }, _toDisplayString(proofUploading.value
                                                            ? _unref(t)("settings.billing.actions.uploading")
                                                            : _unref(t)("settings.billing.actions.submit_proof")), 9, _hoisted_47)
                                                    ], 32))
                                                    : _createCommentVNode("", true),
                                                (_unref(store).tenantInvoices.length === 0)
                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(_unref(t)("settings.billing.detail.no_invoices")), 1))
                                                    : _createCommentVNode("", true),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).tenantInvoices, (invoice) => {
                                                    return (_openBlock(), _createElementBlock("article", {
                                                        key: invoice.id,
                                                        class: "rounded-lg border border-ewhite-100 p-3 text-sm",
                                                        "data-test": "tenant-invoice-row"
                                                    }, [
                                                        _createElementVNode("div", _hoisted_49, [
                                                            _createElementVNode("div", null, [
                                                                _createElementVNode("p", _hoisted_50, " #" + _toDisplayString(invoice.id) + " · " + _toDisplayString(_unref(invoiceLabel)(invoice.status)), 1),
                                                                _createElementVNode("p", _hoisted_51, _toDisplayString(_unref(money)(invoice.total_minor, invoice.currency)) + " · " + _toDisplayString(_unref(dateLabel)(invoice.created_at)), 1)
                                                            ]),
                                                            (invoice.proof.evidence_url)
                                                                ? (_openBlock(), _createElementBlock("a", {
                                                                    key: 0,
                                                                    href: invoice.proof.evidence_url,
                                                                    target: "_blank",
                                                                    rel: "noopener noreferrer",
                                                                    class: "text-xs font-semibold text-eorange-600 hover:underline"
                                                                }, _toDisplayString(_unref(t)("settings.billing.actions.view_proof")), 9, _hoisted_52))
                                                                : _createCommentVNode("", true)
                                                        ]),
                                                        (invoice.proof.status)
                                                            ? (_openBlock(), _createElementBlock("p", _hoisted_53, [
                                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.detail.proof_status")) + ": " + _toDisplayString(invoice.proof.status) + " ", 1),
                                                                (invoice.proof.reference)
                                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_54, "· " + _toDisplayString(invoice.proof.reference), 1))
                                                                    : _createCommentVNode("", true)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ]));
                                                }), 128))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_55, [
                                            (providerSetupPending.value)
                                                ? (_openBlock(), _createElementBlock("aside", _hoisted_56, [
                                                    _createElementVNode("p", _hoisted_57, _toDisplayString(_unref(t)("settings.billing.provider.tenant_setup_title")), 1),
                                                    _createElementVNode("p", _hoisted_58, _toDisplayString(_unref(t)("settings.billing.provider.tenant_setup_description")), 1),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "mt-4 inline-flex h-9 items-center justify-center rounded-lg bg-eblack-900 px-3 text-sm font-semibold text-white hover:bg-eblack-800 disabled:opacity-60",
                                                        disabled: _unref(store).isSaving || setupState.value === 'loading',
                                                        "data-test": "tenant-provider-setup",
                                                        onClick: startProviderSetup
                                                    }, _toDisplayString(setupState.value === "loading"
                                                        ? _unref(t)("settings.billing.provider.setup_loading")
                                                        : _unref(t)("settings.billing.provider.setup_action")), 9, _hoisted_59),
                                                    (setupState.value === 'success')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_60, _toDisplayString(_unref(t)("settings.billing.provider.setup_success")), 1))
                                                        : _createCommentVNode("", true),
                                                    (setupError.value)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_61, _toDisplayString(setupError.value), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("aside", _hoisted_62, [
                                                _createElementVNode("p", _hoisted_63, _toDisplayString(_unref(t)("settings.billing.tenant.recommended_action")), 1),
                                                _createElementVNode("p", {
                                                    class: _normalizeClass(["mt-3 inline-flex rounded-full px-2 py-0.5 text-xs font-semibold", _unref(actionClass)(summary.value.recommended_action.severity)])
                                                }, _toDisplayString(_unref(actionLabel)(summary.value.recommended_action.code)), 3),
                                                _createElementVNode("p", _hoisted_64, _toDisplayString(_unref(actionDescription)(summary.value.recommended_action.code)), 1)
                                            ])
                                        ])
                                    ])
                                ], 64))
                                : _createCommentVNode("", true)
            ]));
        };
    }
});
